import {Flow} from "../../initializeFlows";
import {Controller} from "../../Controller";
import {CalculateShippingPrice} from "../../../../client/state/misc/ShippingPrice.js";
import {MerchantButton} from "../../../common/MerchantButton.jsx";
import {Messages} from "../../../Messages.js";
import {Router} from "../../../../stem-core/src/ui/Router.jsx";
import {PAYMENT_DETAILS_PANEL_URL} from "../../PanelConstants.js";
import {BasePanelPage} from "../../PanelPage";


export class ShopReviewOrderPanel extends BasePanelPage {
    continueFlow() {
        Router.changeURL(PAYMENT_DETAILS_PANEL_URL);
    }

    render() {
        const {styleSheet} = this;
        const product = Flow.shop.selectedProduct;
        const address = Controller.address.selectedAddress;

        return [
            <div>{product.name}</div>,
            address && <div>{address} - {CalculateShippingPrice(address, product.getShippingPrices())}</div>,
            <MerchantButton onClick={() => this.continueFlow()} className={styleSheet.actionButton}>
                {Messages.continueToPayment}
            </MerchantButton>,

            // TODO @Mihai make a component for this
            <div onClick={() => Router.back()} className={styleSheet.backButton}>
                {Messages.back}
            </div>
        ]
    }
}
